const overlay = document.querySelector( '#biro-component-overlay' );

const showOverlay = function() {

  overlay.classList.add( 'is-active' );

}

const hideOverlay = function() {

  overlay.classList.remove( 'is-active' );

}
